module.exports = __webpack_public_path__ + "img/2-2.df39d207.png";